module.exports = __webpack_public_path__ + "media/images/element/child-5fac1c812a6c370664dd221509138db8.svg";